import React, { useEffect, useState, useMemo } from 'react';
import { useMutation } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = {
  '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 },
};

const toDate = (weekStr) => new Date(weekStr.split(/[–-]/)[0].trim());

const CreatorsTable = ({ setCreatorKpi }) => {
  const [creatorData, setCreatorData] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const { mutate: fetchData } = useMutation(client.creators.listKPI, {
    onSuccess: (data) => {
      setCreatorData(data);
      const [latest] = Object.keys(data).sort((a, b) => toDate(b) - toDate(a));
      setCreatorKpi({ progress: data[latest]?.total_partner || 0 });
    },
  });

  useEffect(fetchData, []);

  const sorted = useMemo(
    () =>
      Object.entries(creatorData).sort(
        (a, b) => toDate(b[0]) - toDate(a[0])
      ),
    [creatorData]
  );

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>Associates Added</TableCell>
              <TableCell>Partners Added</TableCell>
              <TableCell>Creators Added</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {sorted
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(([date, d]) => (
                <TableRow key={date}>
                  <TableCell>{date}</TableCell>
                  <TableCell>{d.total_associate}</TableCell>
                  <TableCell>{d.total_partner}</TableCell>
                  <TableCell>{d.total_creators}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={sorted.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(_, p) => setPage(p)}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
      />
    </Paper>
  );
};

export default CreatorsTable;
